/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'cog': {
    width: 800,
    height: 800,
    viewBox: '0 0 16 16',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M6.5 0h3l.594 2.375a5.993 5.993 0 011.728 1l2.356-.674 1.5 2.598-1.76 1.703a6.038 6.038 0 010 1.996l1.76 1.703-1.5 2.598-2.356-.674a5.993 5.993 0 01-1.728 1L9.5 16h-3l-.594-2.376a5.994 5.994 0 01-1.728-.999l-2.356.674-1.5-2.598 1.76-1.703a6.04 6.04 0 010-1.996L.323 5.299l1.5-2.598 2.356.674a5.994 5.994 0 011.728-1L6.5 0zM8 10a2 2 0 100-4 2 2 0 000 4z" _fill="#000"/>'
  }
})
